import React from 'react';

import { Mail, Calendar, CheckCircle, AlertCircle, XCircle, Info } from 'lucide-react';

const CancellationPolicy: React.FC = () => {
  

 
  const WebDesign = () => (
  <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
    <div className="container mx-auto px-4 py-8 sm:px-6 lg:px-8">
      {/* Header Section */}
      <div className="mb-12">
        <div className="flex flex-col items-center text-center sm:flex-row sm:justify-center sm:text-left gap-4 mb-4">
          <div className="flex-shrink-0">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
              <AlertCircle className="w-8 h-8 text-blue-600" />
            </div>
          </div>
          <h1 className="text-2xl sm:text-4xl md:text-5xl font-bold text-gray-900">
            Cancellation Policy
          </h1>
        </div>
        <div className="text-center">
          <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
            <Calendar className="w-4 h-4 mr-2" />
            Effective Date: November 28, 2025
          </div>
        </div>
      </div>

        {/* Policy Content */}
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="p-6 sm:p-8 lg:p-12 space-y-8">
              
              {/* Introduction */}
              <div className="pb-6 border-b border-gray-200">
                <p className="text-gray-700 leading-relaxed text-base sm:text-lg">
                  At <strong>Duri App</strong>, we strive to provide seamless and dependable ridesharing services for both our Hosts ( Ride Givers / Vehicle owners / Hosts) and Guests ( Ride takers /co-travellers). To ensure fairness and accountability, this Cancellation Policy clearly outlines the procedures, penalties, and conditions for both guests  and Hosts when booking and cancelling rides. Please read the policy carefully to understand how cancellations are handled and penalties applied.
        </p>
              </div>

              {/* Section 1 */}
              <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4"> 1. Guest (Co-Traveller) Cancellation Policy</h2>

                    <div className="space-y-4">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">1.1 General Guidelines for Guest (Co-Traveller) Cancellations</h3>
                        <p className="text-gray-700 leading-relaxed mb-3">
                          Guests have the flexibility to manage and cancel their rides within a specific timeframe to suit their changing plans. However, to maintain the efficiency of our Duri App booking system and ensure availability for all users, certain conditions apply:
        </p>
                        <ul className="space-y-2 ml-4">
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">Cancellations are allowed after booking, provided there are at least <strong>1 day / 24 Hours</strong> remaining before the scheduled ride.</span>
          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">If a booking is made <strong>within 4 hours</strong> of the scheduled ride, <strong>no cancellation will be allowed</strong> due to limited availability and last-minute bookings.</span>
          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">Guest (Co-Traveller)s are requested to avoid  cancelling any ride <strong>between 4 hours before</strong> the scheduled start of the trip.</span>
          </li>
        </ul>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">1.2 Cancellation Scenarios and Conditions</h3>

                        <div className="mb-4">
                          <h4 className="text-lg font-medium text-gray-800 mb-2">Booking Cancelled 1 Day Before the Scheduled Ride:</h4>
                          <ul className="space-y-2 ml-4">
                            <li className="flex items-start">
                              <Info className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" />
                              <span className="text-gray-700">If the cancellation is made at least <strong>1day before</strong> the scheduled ride, Guest (Co-Traveller)s can cancel <strong>without any penalty</strong>.</span>
          </li>
                            <li className="flex items-start">
                              <Info className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" />
                              <span className="text-gray-700"><strong>12 Hour Grace Period:</strong> If the booking was made more than 1day before the scheduled ride, a <strong>12-hour grace period</strong> applies during which the Guest (Co-Traveller) can cancel <strong>without any penalty</strong>.</span>
          </li>
        </ul>
                        </div>

                        <div className="mb-4">
                          <h4 className="text-lg font-medium text-gray-800 mb-2">Booking Cancelled Between 12- 4 Hours Before the Ride:</h4>
                          <ul className="space-y-2 ml-4">
                            <li className="flex items-start">
                              <XCircle className="w-5 h-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" />
                              <span className="text-gray-700">If a Guest (Co-Traveller) cancels the booking <strong>between 12-4 hours</strong> before the ride, a penalty rating of <strong>1 Star ( Poor)</strong> will be  automatically applied thereby reducing their chances of next booking.</span>
          </li>
                            <li className="flex items-start">
                              <XCircle className="w-5 h-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" />
                              <span className="text-gray-700">This penalty ensures that our Hosts are compensated for their availability and the inconvenience caused by late cancellations.</span>
          </li>
        </ul>
                        </div>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">1.3 Refund Process</h3>
                        <p className="text-gray-700 leading-relaxed">
                          Since Duri App is not applying any charges , there are no refunds being processed.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">1.4 Ride transfers</h3>
                        <p className="text-gray-700 leading-relaxed mb-2">When a ride needs to be transferred, the initial Host (Ride Givers) must:</p>
                        <ul className="space-y-2 ml-4">
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">Notify the Guest (Co-Traveller) of the change in Host assignment.</span>
          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">Ensure the new Host meets all qualifications and is prepared to fulfill the trip as per the original booking details.</span>
          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">Cooperate with our support team to make the transfer as smooth as possible.</span>
          </li>
        </ul>
                      </div>
                    </div>
                  </div>
                </div>
      </section>

              {/* Section 2 */}
              <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4"> 2. Host Cancellation & Transfer Policy</h2>

                    <div className="space-y-4">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">2.1 General Guidelines for Host Cancellations</h3>
                        <p className="text-gray-700 leading-relaxed mb-3">
                          Our Hosts are a crucial part of our service, and we rely on their professionalism and commitment. To maintain a high standard of service and reliability, we have established guidelines for Hosts when it comes to cancellations:
        </p>
                        <ul className="space-y-2 ml-4">
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">Hosts are expected to <strong>honor all bookings</strong> they accept unless exceptional circumstances arise.</span>
                          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">If a Host must cancel a booking, they are required to do so <strong>at least 24 hours before</strong> the ride start time to avoid inconveniences to co travellers.</span>
                          </li>
        </ul>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">2.2 Cancellation Scenarios and Penalties</h3>

                        <div className="mb-4">
                          <h4 className="text-lg font-medium text-gray-800 mb-2">Cancellation Within 24 Hours of Ride Start Time:</h4>
                          <ul className="space-y-2 ml-4">
                            <li className="flex items-start">
                              <XCircle className="w-5 h-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" />
                              <span className="text-gray-700">If a Host cancels a booking <strong>within 24 hours</strong> of the scheduled ride, penalty vide a <strong>2star rating</strong> shall be applied. This penalty ensures that Guest (Co-Traveller)s are not left stranded due to cancellations.</span>
          </li>
                            <li className="flex items-start">
                              <XCircle className="w-5 h-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" />
                              <span className="text-gray-700">In such cases, the Host is required to make all efforts to <strong>transfer the ride to another available Host</strong>, to ensure the ride continues as scheduled.</span>
          </li>
        </ul>
                        </div>

                        <div className="mb-4">
                          <h4 className="text-lg font-medium text-gray-800 mb-2">Cancellation Due to Emergency:</h4>
                          <ul className="space-y-2 ml-4">
                            <li className="flex items-start">
                              <AlertCircle className="w-5 h-5 text-orange-500 mt-0.5 mr-2 flex-shrink-0" />
                              <span className="text-gray-700">If a cancellation is due to an emergency, the Host must <strong>contact our support team immediately</strong> to report the issue.</span>
                            </li>
                            <li className="flex items-start">
                              <AlertCircle className="w-5 h-5 text-orange-500 mt-0.5 mr-2 flex-shrink-0" />
                              <span className="text-gray-700">While the <strong>1 Star Rating</strong> penalty will still apply for cancellations within 24 hours, Hosts will <strong>not be penalized</strong> if they successfully transfer the booking to another Host in good standing. All penalties thru Poor <strong>1 Star / 2 Star</strong> ratings for cancellations will automatically start reflecting against the Hosts / Guests for next bookings.</span>
                            </li>
                            <li className="flex items-start">
                              <AlertCircle className="w-5 h-5 text-orange-500 mt-0.5 mr-2 flex-shrink-0" />
                              <span className="text-gray-700">These Poor <strong>1Star / 2 Star</strong> Ratings are designed to uphold fairness and ensure that both Guest (Co-Traveller)s and other Hosts performing on time are rated high at <strong>5 Star rating</strong>.</span>
                            </li>
        </ul>
                        </div>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">2.3 Host Obligations During Ride Transfers</h3>
                        <p className="text-gray-700 leading-relaxed">
                          Hosts must ensure that all precautionary measures such as equivalent Car and amenities are provided to Guests. The New Host shall ensure to all the responsibilities are carried out like dropping the Guests at their agreed destination points at same predetermined charges and without hassle to them.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">2.4 Consequences of Repeated Cancellations</h3>
                        <ul className="space-y-2 ml-4">
                          <li className="flex items-start">
                            <XCircle className="w-5 h-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">Consistent cancellations or failure to transfer rides may result in a <strong>review of the Host's performance</strong>.</span>
                          </li>
                          <li className="flex items-start">
                            <XCircle className="w-5 h-5 text-red-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">Persistent violations could lead to <strong>temporary suspension</strong> or <strong>permanent removal</strong> from the platform.</span>
                          </li>
        </ul>
                      </div>
                    </div>
                  </div>
                </div>
      </section>

              {/* Section 3 */}
              <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4"> 3. General Guidelines for Both Guest (Co-Traveller)s and Hosts</h2>

                    <div className="space-y-4">
                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">3.1 Guest and Host Responsibilities</h3>
                        <p className="text-gray-700 leading-relaxed mb-3">Both Guest (Co-Traveller)s and Hosts have responsibilities to maintain the smooth operation of our services:</p>
                        <ul className="space-y-2 ml-4">
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700"><strong>Guest (Co-Traveller)s</strong> are encouraged to only book rides they intend to complete, taking care to cancel within the specified timeframes if plans change.</span>
          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700"><strong>Hosts</strong> should only accept rides they are committed to fulfilling and are responsible for handling cancellations and transfers professionally.</span>
          </li>
        </ul>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">3.2 Communication and Support</h3>
                        <p className="text-gray-700 leading-relaxed mb-3">We understand that unexpected situations can arise. Both Guest (Co-Traveller)s and Hosts are encouraged to reach out to our support team if they face any difficulties or have concerns about a booking:</p>
                        <ul className="space-y-2 ml-4">
                          <li className="flex items-start">
                            <Info className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700"><strong>For Guest (Co-Traveller)s</strong>, please contact our support if user have any questions regarding user booking or need assistance with cancellations.</span>
          </li>
                          <li className="flex items-start">
                            <Info className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700"><strong>For Hosts</strong>, support is available to assist with ride transfers, emergencies, or account-related inquiries.</span>
          </li>
        </ul>
                      </div>

                      <div>
                        <h3 className="text-xl font-semibold text-gray-800 mb-2">3.3 Appeal Process</h3>
                        <p className="text-gray-700 leading-relaxed mb-3">If user believe that a penalty has been wrongly applied, user may appeal the decision by contacting our support team:</p>
                        <ul className="space-y-2 ml-4">
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">Provide the <strong>booking details</strong> and an <strong>explanation</strong> for the appeal.</span>
                          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">Our support team will review the case and provide a resolution within <strong>3 business days</strong>.</span>
                          </li>
                          <li className="flex items-start">
                            <CheckCircle className="w-5 h-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0" />
                            <span className="text-gray-700">The decision of the appeal is <strong>final</strong> to maintain fairness for all users.</span>
                          </li>
        </ul>
                      </div>
                    </div>
                  </div>
                </div>
      </section>

              {/* Section 4 */}
              <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4"> 4. FAQs on Cancellations, and Penalties</h2>

                    <div className="space-y-4">
                      <div>
                        <h4 className="text-lg font-medium text-gray-800 mb-2">4.1 How can I cancel a booking?</h4>
                        <p className="text-gray-700 leading-relaxed">
          user can cancel user booking by logging into user account and accessing the <strong>"My Bookings"</strong> section. Follow the prompts to cancel user ride.
        </p>
                      </div>

                      <div>
                        <h4 className="text-lg font-medium text-gray-800 mb-2">4.2 What happens if my ride is cancelled by the Host?</h4>
                        <p className="text-gray-700 leading-relaxed">
                          If a Host cancels user ride, we will endevor our best  to find a replacement Ride in shortest possible time.
                        </p>
                      </div>

                      <div>
                        <h4 className="text-lg font-medium text-gray-800 mb-2">4.3 How is the penalty calculated for late cancellations?</h4>
                        <p className="text-gray-700 leading-relaxed">
                          The penalty of Poor Star Rating – <strong>1 Star / 2 Star</strong> is based on cumulative weekly / monthly performance and varies depending on when the cancellation occurs.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
      </section>

              {/* Contact Section */}
              <section>
                <div>
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Information</h2>
                    <p className="text-gray-700 leading-relaxed mb-3">
          If user have any questions, concerns, or requests regarding this Cancellation Policy, please contact us at:
        </p>
                    <div className="bg-gradient-to-r from-emerald-50 to-emerald-100 p-4 rounded-xl border border-emerald-200">
                      <div className="flex items-center space-x-3">
                        <Mail className="w-5 h-5 text-emerald-600" />
                        <div>
                          <p className="font-semibold text-emerald-900">DuriApp Guest (Co-Traveller) Support Team</p>
                          <a href="mailto:contact@hansaitechnosoft.com" className="text-emerald-700 hover:text-emerald-900 underline">
                          contact@hansaitechnosoft.com
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
      </section>

            </div>
          </div>
        </div>

        {/* Back to Top Button */}
        <div className="fixed bottom-4 right-4 sm:bottom-8 sm:right-8">
          <button 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg transition-all duration-300 flex items-center justify-center group"
          >
            <svg className="w-6 h-6 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );

  
  return <WebDesign />;
};

export default CancellationPolicy;
